module.exports = __webpack_public_path__ + "static/media/evac-pod-online.7a3f378d.svg";